<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose">
      <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px">
        <el-form-item label="视频标题" prop="name">
          <el-input v-model="formData.name" placeholder="请输入视频标题" clearable :style="{width: '100%'}">
          </el-input>
        </el-form-item>
        <el-form-item label="仓库" prop="name">
          <el-select v-model="formData.userId" clearable>
            <el-option v-for="(item, index) in sellers" :key="index" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作者名称" prop="authorName">
          <el-input v-model="formData.authorName" placeholder="请输入作者名称" clearable :style="{width: '100%'}">
          </el-input>
        </el-form-item>
        <el-form-item label="简要描述" prop="remark">
          <el-input type="textarea" placeholder="请输入简介" v-model="formData.remark" clearable
                    :style="{width: '100%'}"></el-input>
        </el-form-item>
        <el-form-item label="视频图片" prop="coverImg" required>
          <el-upload ref="coverImg" :file-list="coverImgfileList" :action="hostUrl + '/file/upload'"
                     :before-upload="coverImgBeforeUpload" list-type="picture-card" accept="image/*"
                     :on-success="headerCoverImgSuccess">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">只能上传不超过 2MB 的image/*文件，竖屏建议350px*460px，横屏建议350*210px</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频" prop="resources" required>
          <el-upload ref="resources" :file-list="resourcesfileList" :action="hostUrl + '/file/upload'"
                     :on-success="headerSuccess"
                     :before-upload="resourcesBeforeUpload" accept="video/*">
            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传不超过 500MB 的video/*文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频方向" prop="direction">
          <el-radio-group v-model="formData.direction" size="medium">
            <el-radio-button v-for="(item, index) in directionOptions" :key="index" :label="item.value"
                             :disabled="item.disabled">{{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品" prop="resources" required>
          <span>{{ goodsName }}</span>
          <el-button style="margin-left: 20px" size="small" type="primary" @click="$refs['goodsSelect'].openDialog()">
            点击选择商品
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
    <goods-select :multiple="false" :success="selectGoodsCallback" ref="goodsSelect"/>
  </div>
</template>
<script>
import GoodsSelect from '@/views/goods/goods-select'

export default {
  inheritAttrs: false,
  components: {
    GoodsSelect
  },
  props: {
    selectId: {
      type: String,
      require: true
    },
  },
  data() {
    return {
      goodsName: '',
      formData: {
        name: undefined,
        authorName: undefined,
        coverImg: null,
        resources: null,
        direction: "VERTICAL",
        type: 'VIDEO',
        userId: '',
        remark: '',
        goodsId: ''
      },
      rules: {
        userId: [{
          required: true,
          message: '请选择仓库',
          trigger: 'blur'
        }],
        remark: [{
          required: true,
          message: '请输入简要描述',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入视频标题',
          trigger: 'blur'
        }],
        authorName: [{
          required: true,
          message: '请输入作者名称',
          trigger: 'blur'
        }],
        direction: [{
          required: true,
          message: '视频方向不能为空',
          trigger: 'change'
        }],
      },
      directionOptions: [{
        "label": "纵向",
        "value": "VERTICAL"
      }, {
        "label": "横向",
        "value": "HORIZONTAL"
      }],
      hostUrl: config.hostUrl,
      coverImgfileList: [],
      resourcesfileList: [],
      sellers: []
    }
  },
  created() {
    this.findSeller()
  },
  methods: {
    onOpen() {
      this.selectId && this.headerDetail()
    },
    onClose() {
      this.goodsName = ''
      this.$refs['elForm'].resetFields()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('update:select-id', '')
    },
    handelConfirm() {
      this.$refs['elForm'].validate(valid => {
        if (!valid) return
        this.headerSave()
      })
    },
    findSeller() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'seller/pageSeller',
        data: {
          limit: -1
        },
        success: function (response) {
          _this.sellers = response.items;
        }
      });
    },
    coverImgBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2
      if (!isRightSize) {
        this.$message.error('文件大小超过 2MB')
      }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isRightSize && isAccept
    },
    resourcesBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 500
      if (!isRightSize) {
        this.$message.error('文件大小超过 500MB')
      }
      let isAccept = new RegExp('video/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择video/*类型的文件')
      }
      return isRightSize && isAccept
    },
    headerSuccess(e) {
      this.$set(this.formData, 'resources', e.msg)
    },
    headerCoverImgSuccess(e) {
      this.$set(this.formData, 'coverImg', e.msg)
    },
    headerSave() {
      const _this = this;
      _this.$common.my_ajax({
        url: '/media/saveMedia',
        data: _this.formData,
        success: () => {
          _this.$notify.success("保存成功")
          _this.$emit("getList")
          _this.close()
        }
      });
    },
    headerDetail() {
      const _this = this;
      _this.$common.my_ajax({
        url: '/media/detailMedia',
        data: {
          mediaId: this.selectId
        },
        success: (resp) => {
          this.formData = resp.item
          this.coverImgfileList = [{url: `https:/admin.nfdays.com/${resp.item.coverImg}`}]
          resp.item.goodsId && _this.$common.my_ajax({
            url: '/goods/detailGoods',
            data: {
              goodsId: resp.item.goodsId
            },
            success: (resp) => {
              _this.goodsName = resp.item.name
            }
          });
        }
      });

    },
    selectGoodsCallback(g) {
      this.$set(this.formData, 'goodsId', g.id)
      this.goodsName = g.name
      this.$refs['goodsSelect'].closeDialog();
    },
  }
}

</script>
<style>
.el-upload__tip {
  line-height: 1.2;
}

</style>
